<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color">{{ heading }} </h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>

<mat-dialog-content class="mt-16 pt-4 !py-0">




    <google-map #map height="500px" width="100%" [center]="mapCenter" [zoom]="zoom">
        <!-- Origin marker (driver) -->

        <!-- Show pickup marker when order is not picked up -->
        <map-marker *ngIf="this.pickupCoords && !isOrderPickedUp" [position]="pickupCoords"
            [options]="{ icon: markerOptions.pickup.icon }">
        </map-marker>

        <!-- Show destination marker when order is picked up -->
        <map-marker *ngIf="dir.destination && isOrderPickedUp" [position]="dir.destination"
            [options]="{ icon: markerOptions.destination.icon }">
        </map-marker>

        <!-- Show waypoint markers when order is picked up -->
        <ng-container *ngIf="isOrderPickedUp">
            <map-marker *ngFor="let wp of waypoints" [position]="wp.location"
                [options]="{ icon: markerOptions.destination.icon }">
            </map-marker>
        </ng-container>

        <!-- Route path -->
        <map-polyline *ngIf="routePath.length > 1" [path]="routePath" [options]="polylineOptions">
        </map-polyline>
    </google-map>
</mat-dialog-content>

<mat-dialog-actions class="!px-0 justify-center">
    <button color="primary" mat-dialog-close
        class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color" mat-flat-button>
        OK
    </button>
</mat-dialog-actions>